/**
 * The few words the components say themselves. English by default; the
 * app sets its translations with setUiStrings when the locale changes.
 */
export interface UiStrings {
  readonly cancel: string;
  readonly close: string;
  readonly loading: string;
  readonly noEntries: string;
  readonly account: string;
  readonly accountSearch: string;
  readonly noAccount: string;
}

let strings: UiStrings = {
  cancel: 'Cancel',
  close: 'Close',
  loading: 'Loading',
  noEntries: 'No entries',
  account: 'Account',
  accountSearch: 'Number or name',
  noAccount: 'No account found'
};

export function setUiStrings(next: Partial<UiStrings>): void {
  strings = { ...strings, ...next };
}

export function uiString(key: keyof UiStrings): string {
  return strings[key];
}
